<template>
    <v-container>
      <div>
        <v-row justify="space-between">
          <v-col cols="12" sm="6" justify="center">
            <p class="header-title"> {{$t('gift_manager.title')}} </p>
          </v-col>

          <v-col cols="12" sm="6" justify="center" class="pr-5">
            <v-row class="d-flex justify-end">
              <v-dialog v-model="dialog" persistent max-width="60%">
                  <template v-slot:activator="{ on }">
                      <v-btn color="primary" dark class="mb-2" v-on="on">{{ $t('common.add')}}</v-btn>
                  </template>
                  <v-card>
                      <v-card-title>
                          <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                          <v-container>
                            <v-row no-gutters>
                                <v-col cols="12" sm="6" class="pr-5">
                                    <v-text-field v-model="editedItem.code" :rules="stringRules" v-bind:label="$t('gift_manager.code')" outlined dense></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6" class="pl-5">
                                    <v-text-field v-model="editedItem.name" :rules="stringRules" v-bind:label="$t('gift_manager.name')" outlined dense></v-text-field>
                                </v-col>
                            </v-row>
                            
                            <v-row no-gutters>
                                <v-col cols="12" sm="6" class="pr-5">
                                    <v-text-field v-model="editedItem.manufacturer" :rules="stringRules" v-bind:label="$t('gift_manager.manufacturer')" outlined dense></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6" class="pl-5">
                                    <!-- <v-text-field v-model="editedItem.qty" type="number" v-bind:label="$t('gift_manager.qty')" min="0"></v-text-field> -->
                                    <v-numeric-field v-model="editedItem.qty" v-bind:label="$t('gift_manager.qty')" outlined dense></v-numeric-field>
                                </v-col>
                            </v-row>
                            
                            <v-row no-gutters>
                                <v-col cols="12" sm="6" class="pr-5">
                                  <!-- <v-text-field  v-model="date" :rules="stringRules" type="date" v-bind:label="$t('gift_manager.time_available')" outlined></v-text-field> -->
                                  <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" persistent width="290px">
                                    <template v-slot:activator="{ on }">
                                      <v-text-field v-model="computedDateFormatted" v-bind:label="$t('gift_manager.time_available')" readonly v-on="on" outlined dense></v-text-field>
                                    </template>
                                    <v-date-picker v-model="date" scrollable locale="vi">
                                      <v-spacer></v-spacer>
                                      <v-btn text color="primary" @click="modal = false"> {{ $t('common.cancel') }} </v-btn>
                                      <v-btn text color="primary" @click="$refs.dialog.save(date)"> {{ $t('common.ok') }} </v-btn>
                                    </v-date-picker>
                                  </v-dialog>
                                </v-col>

                                <v-col cols="12" sm="6" class="pl-5">
                                    <!-- <v-text-field v-model="editedItem.minimum_number" type="number" v-bind:label="$t('gift_manager.minimum')" min="0"></v-text-field> -->
                                    <v-numeric-field v-model="editedItem.minimum_number" v-bind:label="$t('gift_manager.minimum')" outlined dense></v-numeric-field>
                                </v-col>
                            </v-row>

                            <v-row no-gutters>
                                <v-col cols="12" sm="6" class="pr-5">
                                    <!-- <v-text-field v-model="editedItem.maximum_number" type="number" v-bind:label="$t('gift_manager.maximum')" min="0"></v-text-field> -->
                                    <v-numeric-field v-model="editedItem.maximum_number" v-bind:label="$t('gift_manager.maximum')" outlined dense></v-numeric-field>
                                </v-col>

                                <v-col cols="12" sm="6" class="pl-5">
                                    <v-combobox v-model="selectCondition" :items="conditions" v-bind:label="$t('gift_manager.condition')" outlined dense></v-combobox>
                                </v-col>
                            </v-row>

                            <v-row no-gutters>
                                <v-col>
                                    <!-- <v-combobox v-model="selectStatus" :items="status" v-bind:label="$t('gift_manager.status')"></v-combobox> -->
                                    {{$t('gift_manager.status')}}
                                    <v-switch v-model="selectStatus" :true-value="1" :false-value="0" color="primary"></v-switch>
                                </v-col>
                            </v-row>
                          </v-container>
                      </v-card-text>

                      <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" dark @click="close">{{ $t('common.cancel')}}</v-btn>
                          <v-btn color="primary" dark @click="save">{{ $t('common.save')}}</v-btn>
                      </v-card-actions>
                  </v-card>
              </v-dialog>
            </v-row>
              
          </v-col>
        </v-row>
      </div>
      <v-data-table :headers="headers" :items="desserts" :search="search" :loading="loading" sort-by="email" class="elevation-1" hide-default-footer :page.sync="page" :items-per-page="itemsPerPage"  @page-count="pageCount = $event">
          <template v-slot:top>
            <v-toolbar flat color="white" class="pt-5">
              <v-row justify="start">
                <v-col cols="12" sm="1">
                    <v-autocomplete v-model="itemsPerPage" :items="numberPage" outlined :dense="true"></v-autocomplete>
                </v-col>

                <v-col cols="12" sm="2">
                </v-col>
                
                <v-col cols="12" sm="2">
                </v-col>

                <v-col cols="12" sm="7">
                    <v-text-field v-model="search" append-icon="search" v-bind:label="$t('common.search')" single-line hide-details outlined :dense="true"></v-text-field>
                </v-col>
              </v-row>
            </v-toolbar>
          </template>

          <template v-slot:[`item.action`]="{ item }">
              <v-icon  small class="mr-2"  @click="editItem(item)">
                  edit
              </v-icon>
              <v-icon  small @click="deleteItem(item)">
                  delete
              </v-icon>

          </template>

          <template v-slot:[`item.time_available`]="{ item }">
              <span>{{item.time_available | formateDate}}</span>
          </template>

          <template v-slot:[`item.status`]="{ item }">
            <v-switch :true-value="1" :false-value="0" v-model="item.status" color="primary" readonly> </v-switch>
          </template>

          <template v-slot:[`item.condition`]="{ item }">
              <span>{{conditions[item.condition]}}</span>
          </template>

          <template v-slot:[`item.name`]="{ item }">
              <span class="contentName">
                {{ item.name }}
              </span>
          </template>

          <template v-slot:[`item.qty`]="{ item }">
              <span class="contentName">
                {{ thousandSeprator(item.qty) }}
              </span>
          </template>

          <template v-slot:[`item.minimum_number`]="{ item }">
              <span class="contentName">
                {{ thousandSeprator(item.minimum_number) }}
              </span>
          </template>

          <template v-slot:[`item.maximum_number`]="{ item }">
              <span class="contentName">
                {{ thousandSeprator(item.maximum_number) }}
              </span>
          </template>

          <template v-slot:[`item.manufacturer`]="{ item }">
              <span class="contentName">
                {{ item.manufacturer }}
              </span>
          </template>

          <template v-slot:no-data>
              <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
          </template>
      </v-data-table>

      <div class="text-center pt-2">
        <v-pagination v-model="page" :length="pageCount"></v-pagination>
      </div>
    </v-container>
</template>

<script>
  import i18n from '@/plugins/i18n';
  import moment from 'moment';
  // import MoneyInput from "@/components/MoneyInput";
  import VNumericField from "@/components/VNumericField";

  export default {
    data: () => ({
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,

      loading: true,
      numberPage: [
        5, 10, 15, 20, 25
      ],

      date: moment(String(new Date())).format("YYYY-MM-DD"),
      modal: false,

      search: '',
      dialog: false,
      headers: [
        { text: '#', align: 'left', sortable: false, value: 'index', },
        { text: i18n.t('gift_manager.code'), value: 'code' },
        { text: i18n.t('gift_manager.name'), value: 'name' },
        { text: i18n.t('gift_manager.manufacturer'), value: 'manufacturer' },
        { text: i18n.t('gift_manager.qty'), value: 'qty' },
        { text: i18n.t('gift_manager.time_available'), value: 'time_available' },
        { text: i18n.t('gift_manager.minimum'), value: 'minimum_number' },
        { text: i18n.t('gift_manager.maximum'), value: 'maximum_number' },
        { text: i18n.t('gift_manager.condition'), value: 'condition' },
        { text: i18n.t('gift_manager.status'), value: 'status' },
        { text: '', value: 'action', sortable: false }
      ],
      desserts: [],
      editedIndex: -1,
      selectCondition: 'All',
      selectStatus: 1,
      editedItem: {
        // status: 1
      },
      defaultItem: {
      },
      stringRules: [
        v => !!v || i18n.t('validate.not_empty')
      ],
      status: [
        false,
        true
      ],
      conditions: [
        'Any',
        'All'
      ]
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? i18n.t('gift_manager.add') : i18n.t('gift_manager.edit')
      },

      computedDateFormatted () {
        return this.formatDate(this.date)
      },
    },

    components: {
       VNumericField: VNumericField
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.getData()
    },

    methods: {
      initialize () {
      },

      formatDate (date) {
        if (!date) {
          return null;
        }

        const [year, month, day] = date.split('-')
        return `${month}/${day}/${year}`
      },

      editItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.date = moment(String(this.editedItem.time_available)).format("YYYY-MM-DD");
        this.selectCondition = this.conditions[this.editedItem.condition];
        this.selectStatus = this.editedItem.status;
        this.dialog = true
      },

      async deleteItem (item) {
        const agree = confirm(i18n.t('common.confirm_delete'))
        if (agree) {
          const response =  await this.$http.delete("/gift/" + item._id);
          if(response.data && response.data.success) {
              this.desserts.splice(item.index - 1, 1);
              this.desserts.forEach((item, index) =>item.index = index + 1);
          } else if(response.data && !response.data.success) {
              alert(i18n.t(response.data.message));
          } else {
              alert(i18n.t('validate.request_error'));
          }
        }
      },

      close () {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedItem.qty = 0;
        this.editedItem.maximum_number = 0;
        this.editedItem.minimum_number = 0;

        this.dialog = false;
        this.editedIndex = -1
        // setTimeout(() => {
          
          
        // }, 300)
      },

      async save () {
        if (!this.editedItem.name || this.editedItem.name.length == 0) {
          alert(i18n.t('validate.infor_empty'));
          return;
        }

        if (!this.editedItem.code || this.editedItem.code.length == 0) {
          alert(i18n.t('validate.infor_empty'));
          return;
        }

        if (!this.date) {
          alert(i18n.t('validate.infor_empty'));
          return;
        }

        const self = this;

        if (this.editedIndex > -1) {
          try {
            self.editedItem.condition = self.conditions.indexOf(self.selectCondition);
            self.editedItem.status = self.selectStatus;
            const requestBody = {};
            Object.assign(requestBody, self.editedItem);
            requestBody.time_available = moment(String(this.date)).format("DD/MM/YYYY");
            self.editedItem.time_available = this.date;
            
            const response = await this.$http.put('/gift/' + self.editedItem._id,  requestBody);

            if (response.data && response.data.success) {
                Object.assign(this.desserts[this.editedIndex], this.editedItem);
                self.editedItem = {};

                this.$fire({
                    title: i18n.t('common.update_success'),
                    text: "",
                    type: "success"
                    }).then(() => {
                        
                });
            } else if(response.data && !response.data.success) {
                alert(i18n.t(response.data.message));
            } else {
                alert(i18n.t('validate.request_error'));
            }
          } catch (e) {
              console.log(e.stack);
              alert(i18n.t('validate.request_error'));
          }
        } else {
          try {
            self.editedItem.condition = self.conditions.indexOf(self.selectCondition);
            self.editedItem.status = self.selectStatus;
            const requestBody = {};
            Object.assign(requestBody, self.editedItem);
            requestBody.time_available = moment(String(this.date)).format("DD/MM/YYYY");
            self.editedItem.time_available = this.date

            console.log(requestBody);
            const response = await this.$http.post('/gift', requestBody);

            if (response.data && response.data.success) {
                self.editedItem._id = response.data.data.id;
                
                this.desserts.push(self.editedItem);
                self.editedItem.index = this.desserts.length;
                self.editedItem = {};

                this.$fire({
                    title: i18n.t('common.success'),
                    text: "",
                    type: "success"
                    }).then(() => {
                        
                });
            } else if(response.data && !response.data.success) {
                alert(i18n.t(response.data.message));
            } else {
                alert(i18n.t('validate.request_error'));
            }
          } catch (e) {
              console.log(e.stack);
              alert(i18n.t('validate.request_error'));
          }
        }
        this.close()
      },

      async getData() {
        try {
            const response = await this.$http.get('/gift');
            if (response.data && response.data.success) {
                const contextArr = response.data.data;
                contextArr.forEach((item, index) =>item.index = index + 1);

                this.desserts = contextArr;
                this.loading = false;
            }
        } catch (e) {
            console.log(e.stack);
        }
      },

      thousandSeprator(amount) {
        if (amount !== '' || amount !== undefined || amount !== 0  || amount !== '0' || amount !== null) {
          return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        } else {
            return amount;
        }
      }
    },
  }
</script>